import React from "react"
import EquipmentStore from "../../../stores/EquipmentStore"
import autobind from "class-autobind"
import { PieChart } from "react-d3-basic"
import strings from "../../../localization/strings"
import moment from "moment"
import * as timeHelper from "../../../helpers/timeHelper"
import { IObjectTimecardDocument } from "../../../models"
interface IProps {

}
interface IState {
    timecard: IObjectTimecardDocument
    chartData: { type: string, time: number }[]
    utilized: number
    chartSeries: { field: string, name: string, color: string }[]
}

export default class EquipmentDetailChartSummary extends React.Component<IProps, IState> {
    private total = 168
    constructor(props) {
        super(props)
        this.state = {
            chartData: null,
            utilized: 0,
            timecard: null,
            chartSeries: [
                {
                    field: "Utilized",
                    name: strings.Utilized,
                    color: "#4CAF50"
                },
                {
                    field: "Unutilized",
                    name: strings.Unutilized,
                    color: "#BDBDBD"
                }
            ]
        }
        autobind(this)
    }

    componentDidMount() {
        EquipmentStore.on("change", this.changeSelectedEquipmentTimecard)
    }

    componentWillUnmount() {
        EquipmentStore.removeListener("change", this.changeSelectedEquipmentTimecard)
    }

    changeSelectedEquipmentTimecard() {
        const timecard = EquipmentStore.getSelectedEquipmentTimecard()
        let utilized
        if (timecard) {
            const temp = timeHelper.convertToHour(timecard.MasterTimecard.TimecardWeeks[0].TotalDurationInMinutes)
            utilized = temp > this.total ? this.total : temp
        } else {
            utilized = 0
        }

        const utilizedPercent = Math.floor((utilized / this.total) * 10000) / 100
        const chartSeries = [
            {
                field: "Utilized",
                name: utilizedPercent + "%  " + strings.Utilized,
                color: "#4CAF50"
            },
            {
                field: "Unutilized",
                name: Math.round(100 - utilizedPercent) + "%  " + strings.Unutilized,
                color: "#BDBDBD"
            }
        ]

        this.setState({
            chartData: [
                {
                    type: "Utilized",
                    time: utilized < 0.5 ? 0.5 : utilized
                },
                {
                    type: "Unutilized",
                    time: utilized < 0.5 ? 167.5 : this.total - utilized
                }
            ],
            utilized,
            timecard,
            chartSeries
        })
    }

    value(d) {
        return +d.time
    }

    name(d) {
        return d.type
    }

    render() {
        return (
            <div className="EquipmentDetailChartSummary" style={{ position: "relative" }}>
                <div style={{ fontSize: 20, fontWeight: 500, marginTop: 10 }}>{strings.Utilization}</div>
                <div style={{ marginTop: 7 }}>
                    {this.state.timecard && (
                        <span style={{ fontSize: 15 }}>
                            {moment(this.state.timecard.StartDate).utc().format("ddd MMM. DD, YYYY")}
                            &mdash;
                            {moment(this.state.timecard.EndDate).utc().format("ddd MMM. DD, YYYY")}
                        </span>
                    )}
                </div>
                {this.state.chartData &&
                    <div style={{ position: "relative" }}>
                        <div style={{ position: "absolute", top: -20, left: 0, right: 0 }}>
                            <PieChart
                                outerRadius={100}
                                showLegend={false}
                                width={400}
                                height={293}
                                data={this.state.chartData}
                                chartSeries={this.state.chartSeries}
                                value={this.value}
                                name={this.name}
                            />
                        </div>
                        <div style={{ position: "absolute", left: 0, right: 0, top: 270 }}>
                            <div>
                                <div style={{ width: 100, height: 10, backgroundColor: "#4CAF50", display: "inline-block" }} />
                                <div style={{ display: "inline-block", width: 80, marginLeft: 10, textAlign: "left", fontSize: 15 }}>
                                    {this.state.utilized + " hrs"}
                                </div>
                            </div>
                            <div>
                                <div style={{ width: 100, height: 10, backgroundColor: "#BDBDBD", display: "inline-block" }} />
                                <div style={{ display: "inline-block", width: 80, marginLeft: 10, textAlign: "left", fontSize: 15 }}>
                                    {Math.round(this.total - this.state.utilized) + " hrs"}
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}
